module.exports = __webpack_public_path__ + "close-new.svg?4f9664000d090b3d585b463886b8d7a6";